import { useEffect } from 'react'
import { router } from '@inertiajs/react'
import { Loader2 } from 'lucide-react'
import { investigationUrl } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function InvestigationScopeRecovery({ projectId, copy }: { projectId?: string; copy: InvestigationLabels }) {
  useEffect(() => {
    // Never derive the recovery target from a late response's project or URL.
    router.visit(projectId ? investigationUrl(projectId) : '/dashboard/discovery/projects', { replace: true })
  }, [projectId])
  return <div role="status" className="flex items-center gap-2 p-6 text-sm text-muted-foreground"><Loader2 className="size-4 animate-spin" aria-hidden />{copy.context_refreshing}</div>
}
